import { IMessage, MessageTypes } from './Interfaces';

type MessageListener = (message: MessageEvent<IMessage>) => void;

class MessageBus {
  private static _instance: MessageBus;
  private listeners: Set<MessageListener>;

  private constructor() {
    this.listeners = new Set<MessageListener>();
    this.initListener();
  }

  public static getInstance(): MessageBus {
    if (!MessageBus._instance) {
      MessageBus._instance = new MessageBus();
    }
    return MessageBus._instance;
  }

  private initListener(): void {
    window.addEventListener('message', (event: MessageEvent<IMessage>) => {
      this.listeners.forEach((listener) => listener(event));
    });
  }

  public subscribe(messageType: MessageTypes, handler: (message: MessageEvent<IMessage>) => void): () => void {
    const filteredListener = (event: MessageEvent<IMessage>) => {
      if (event.data.type === messageType) {
        handler(event);
      }
    };

    this.listeners.add(filteredListener);
    return () => {
      this.listeners.delete(filteredListener);
    };
  }

  public unsubscribe(listener: MessageListener): void {
    this.listeners.delete(listener);
  }

  public send(message: IMessage, targetWindow: Window = window.parent, targetOrigin = '*'): void {
    targetWindow.postMessage(message, targetOrigin);
  }
}

export default MessageBus.getInstance();
